// extracted by mini-css-extract-plugin
module.exports = {"shadow":"settings-section_shadow__33CsA","textShadow":"settings-section_textShadow__1WVuR","wrapper":"settings-section_wrapper__hEGXS","content":"settings-section_content__2f2Ua"};